import { z } from "zod";
import { emailField } from "@smeetz/services-validation";

export interface SendEmailValues {
  email: string;
}

/**
 * Zod schema for the send-email form.
 *
 * @returns {z.ZodType<SendEmailValues>} schema validating an optional email.
 */
export function sendEmailSchema() {
  return z.object({
    email: emailField({ optional: true }),
  });
}
